// this handles the value that either an Array or string
// to get a string value only

const extractString = (value: string | string[]) => {
  return Array.isArray(value) ? value?.[0] || "" : value || "";
};

export default extractString;
